<template>
  <div>
    <Modal v-model="modal1" width="350" class="modal_title"  @on-cancel="close()">
      <div>
        <loginCom :is-dialog-login="true" @closeDialog="closeShow"></loginCom>
      </div>
    </Modal>
  </div>
</template>

<script>
import loginCom from "@/components/hm_personal/LoginCom";
export default {
  name: "LoginPop",
  components:{
    loginCom
  },
  props:{
    // modal1:{
    //   type:Boolean,
    //   default:false
    // }
  },
  data() {
    return {
      modal1:true
    }
  },
  methods:{

    // 不登录关闭
    close(){
      this.$emit('closeDialog', "close")
    },

    // 登录关闭
    closeShow(){
      this.$emit('closeDialog')
      // this.modal1 = false
    }
  }
}
</script>

<style scoped lang="scss">
.modal_title {
  /deep/ {
    .ivu-modal-header {
      border-bottom: none;
    }
    .ivu-modal-content{
      height: 410px;
    }

    .ivu-modal-body {
      padding: 0;
    }

    .ivu-modal-footer {
      border-top: none;
    }

    .ivu-modal-footer .ivu-btn {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hm_personal/LoginPop.vue